import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import Image from 'components/Image';
import Link from 'components/Link';
import i18n from 'i18n';
import slugify from 'lib/slugify';
import { toQS } from 'lib/query-params';
import { removeFromComparisons, clearComparisons } from 'actions/products';

export default class CompareContainer extends Component {
  clear = (e) => {
    e.preventDefault();
    this.props.dispatch(clearComparisons());
  };

  onRemove = (item) => (e) => {
    e.preventDefault();
    this.props.dispatch(removeFromComparisons(item));
  };

  render() {
    const { children, comparisons } = this.props;
    const [a, b] = comparisons;
    const compareParams = toQS({
      product1: a && slugify(a.id, a.name),
      product2: b && slugify(b.id, b.name),
      app: this.context.app
    });

    return (
      <Fragment>
        {comparisons.length > 0 && (
          <FloatingContainer>
            <Alert color="paradiso" className="m-0 rounded-0">
              <div className="container px-lg-3 px-0">
                <div className="row">
                  <div className="col-12 col-lg-8 offset-lg-3">
                    <div className="pb-2">
                      {comparisons.length === 1 && (
                        <strong>{i18n.t('SELECT_ONE_MORE')}</strong>
                      )}
                      {comparisons.length === 2 &&
                        i18n.t('COMPARE_LIMIT_PRODUCTS')}
                    </div>
                    <ProductsContainer className="pb-3 mb-3 d-flex">
                      {a && <Product {...a} onRemove={this.onRemove(a)} />}
                      {b && <Product {...b} onRemove={this.onRemove(b)} />}
                    </ProductsContainer>
                    <div className="text-center">
                      {comparisons.length <= 1 && (
                        <Link
                          route="/categories"
                          className="btn btn-link text-paradiso">
                          {i18n.t('ADD_PRODUCT')}
                        </Link>
                      )}
                      {comparisons.length >= 2 && (
                        <Link
                          route={`/compare?${compareParams}`}
                          className="btn btn-paradiso">
                          {i18n.t('COMPARE_NOW')}
                        </Link>
                      )}
                      <a
                        href=""
                        className="btn btn-link text-danger"
                        onClick={this.clear}>
                        {i18n.t('CLEAR')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Alert>
          </FloatingContainer>
        )}
        {children}
      </Fragment>
    );
  }
}

CompareContainer.propTypes = {
  children: PropTypes.node,
  comparisons: PropTypes.array,
  dispatch: PropTypes.func
};

CompareContainer.contextTypes = {
  lang: PropTypes.string,
  app: PropTypes.string
};

const FloatingContainer = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 9999;
`;

function Product({ name, brand, image, onRemove }) {
  return (
    <div className="d-flex small w-100 position-relative">
      <Image
        alt={name}
        src={image.thumb || '/static/images/img-placeholder.svg'}
        width={30}
        style={{ maxHeight: 30, marginRight: 10 }}
      />
      <div>
        <div>{brand && brand.name}</div>
        <span className="text-muted">{name}</span>
      </div>
      <IconTrash href="/" onClick={onRemove}>
        <i className="fa fa-trash-alt" />
      </IconTrash>
    </div>
  );
}

Product.propTypes = {
  name: PropTypes.string,
  brand: PropTypes.object,
  image: PropTypes.shape({ thumb: PropTypes.string }),
  onRemove: PropTypes.func
};

const ProductsContainer = styled.div`
  border-bottom: 1px solid #ccd9db;
`;

const IconTrash = styled.a.attrs({
  className: 'text-danger'
})`
  position: absolute;
  right: 10px;
`;
